<div class="flex flex-col w-full relative">
    <!-- Label with optional required asterisk -->
    <label *ngIf="label"
        class="flex items-center gap-1 text-[10px] font-black text-text-muted uppercase tracking-[0.2em] ml-1">
        {{ label }}
        <span *ngIf="required" class="text-red-500 font-black text-lg">*</span>
    </label>

    <div class="relative group">
        <!-- Left Icon -->
        <div *ngIf="icon"
            class="absolute left-3.5 top-1/2 -translate-y-1/2 text-text-muted group-focus-within:text-primary transition-colors z-10 pointer-events-none flex items-center">
            <iconify-icon [attr.icon]="icon" width="17" height="17"></iconify-icon>
        </div>

        <!-- Trigger Button -->
        <button type="button" (click)="toggleDropdown()" [disabled]="disabled"
            [ngClass]="[sizeClasses, variantClasses, isOpen() ? 'border-primary ring-2 ring-primary/10' : '']"
            class="w-full flex items-center text-left bg-white dark:bg-slate-800/40 border border-foreground/25 dark:border-white/15 rounded-xl transition-all duration-200 outline-none
             hover:border-primary/40 focus:border-primary focus:ring-2 focus:ring-primary/10 placeholder:text-text-muted/60
             disabled:opacity-50 disabled:cursor-not-allowed read-only:opacity-60 read-only:cursor-not-allowed text-foreground font-medium" [class.pl-10]="icon" [class.pr-10]="true" [class.!border-red-400]="error"
            [class.!focus:ring-red-400/10]="error">

            <span class="flex-1 min-w-0 truncate" [class.opacity-40]="!selectedLabel">
                <div class="flex items-center gap-2">
                    <div *ngIf="value && visualType !== 'none'" class="shrink-0 flex items-center">
                        <iconify-icon *ngIf="visualType === 'icon'" [attr.icon]="value" width="16" [ngClass]="visualColor"></iconify-icon>
                        <div *ngIf="visualType === 'color'" [ngClass]="value.replace('text-', 'bg-')" class="w-3.5 h-3.5 rounded-full border border-black/10 shadow-sm"></div>
                    </div>
                    <span>{{ selectedLabel || placeholder }}</span>
                </div>
            </span>


            <!-- Custom Arrow Icon -->
            <div class="absolute right-3 top-1/2 -translate-y-1/2 text-text-muted pointer-events-none flex items-center opacity-40 group-hover:opacity-100 transition-all"
                [class.rotate-180]="isOpen()">
                <iconify-icon icon="solar:alt-arrow-down-bold-duotone" width="18" height="18"></iconify-icon>
            </div>
        </button>

        <!-- Custom Dropdown Panel -->
        <div *ngIf="isOpen()" [ngStyle]="dropdownStyle()" [ngClass]="[
                direction() === 'down' ? 'animate-modal-up origin-top' : 'animate-fade-in-up origin-bottom',
                !insideDialog ? 'absolute top-full left-0 right-0 mt-1 z-50' : ''
             ]"
            class="bg-surface dark:bg-[#071527] backdrop-blur-xl border border-foreground/25 dark:border-white/15 rounded-2xl shadow-2xl overflow-hidden py-2">

            <div class="max-h-60 overflow-y-auto custom-scrollbar">
                <div *ngIf="placeholder" (click)="selectOption(null)" [ngClass]="optionSizeClasses"
                    class="font-black uppercase text-foreground/75 hover:bg-foreground/[0.03] cursor-pointer transition-colors border-b border-foreground/[0.03]">
                    {{ placeholder }}
                </div>

                <div *ngFor="let opt of options" (click)="selectOption(opt.value)" [ngClass]="optionSizeClasses"
                    class="px-5 py-4 font-bold text-foreground/80 hover:text-primary hover:bg-primary/10 cursor-pointer transition-all flex items-center justify-between group/opt"
                    [class.bg-primary/5]="value === opt.value" [class.text-primary]="value === opt.value">
                    <div class="flex items-center gap-3">
                        <div *ngIf="visualType !== 'none' && opt.value !== 'custom'" class="shrink-0 flex items-center">
                            <iconify-icon *ngIf="visualType === 'icon'" [attr.icon]="opt.value" width="18" [ngClass]="visualColor"></iconify-icon>
                            <div *ngIf="visualType === 'color'" [ngClass]="opt.value.replace('text-', 'bg-')" class="w-4 h-4 rounded-full border border-black/10 shadow-sm"></div>
                        </div>
                        <iconify-icon *ngIf="opt.value === 'custom'" icon="solar:pen-new-square-bold" width="18" class="text-slate-500"></iconify-icon>
                        <span>{{ opt.label }}</span>
                    </div>
                    <iconify-icon icon="solar:check-circle-bold-duotone"
                        class="text-primary text-xl opacity-0 group-hover/opt:opacity-100 transition-all"
                        [class.opacity-100]="value === opt.value"></iconify-icon>
                </div>

                <div *ngIf="options.length === 0"
                    class="px-6 py-8 text-center text-[10px] font-black uppercase tracking-widest text-foreground/60 italic">
                    No hay opciones
                </div>
            </div>
        </div>
    </div>

    <!-- Help text (only if no error) -->
    <span *ngIf="helperText && !error"
        class="mt-1.5 ml-1 text-[9px] font-bold text-text-muted/60 uppercase tracking-tighter">
        {{ helperText }}
    </span>

    <!-- Error message -->
    <span *ngIf="error"
        class="mt-1.5 ml-1 text-[9px] font-black text-red-500 uppercase tracking-tighter animate-fade-in flex items-center gap-1.5">
        <iconify-icon icon="solar:danger-bold-duotone" width="12" height="12"></iconify-icon>
        {{ error }}
    </span>
</div>